import { inject, Injectable } from '@angular/core';

import { Storage } from '@ionic/storage-angular';
import { Store } from '@ngrx/store';

import * as CordovaSQLiteDriver from 'localforage-cordovasqlitedriver';
import { throttleTime } from 'rxjs';

import { SmdState } from '../../store';
import { OldState } from '../../typings/storage';
import * as fromPersistedStateActions from './../../store/actions/persisted-state.actions';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private storage = inject(Storage);
  private store = inject(Store);

  private storageInstance: Storage | null = null;
  private stateKey = 'state';
  private oldStateKey = 'app';

  async init() {
    await this.storage.defineDriver(CordovaSQLiteDriver);
    this.storageInstance = await this.storage.create();
    const oldState: OldState = await this.get(this.oldStateKey);

    if (oldState) {
      this.store.dispatch(fromPersistedStateActions.migratePersistedOldStateReferralCode({ payload: oldState }));
    } else {
      const persisted = await this.get(this.stateKey);

      if (persisted) {
        try {
          const state: SmdState = JSON.parse(persisted);
          this.store.dispatch(fromPersistedStateActions.loadPersistedStateSuccess({ payload: state }));
        } catch (e) {
          this.store.dispatch(
            fromPersistedStateActions.loadPersistedStateFailure({ payload: { error: e as unknown as Error } })
          );
        }
      }
    }
    this.store.pipe(throttleTime(500, undefined, { leading: true, trailing: true })).subscribe((state) => {
      this.set(this.stateKey, JSON.stringify(state));
    });
  }

  public async set(key: string, value: string) {
    await this.storageInstance?.set(key, value);
  }

  public async get(key: string) {
    return await this.storageInstance?.get(key);
  }

  public async removeOldState() {
    await this.storageInstance?.remove(this.oldStateKey);
  }
}
